import * as Mutation from './mutation-types'
import TarefaApi from "@/services/tarefaApi"

export default {
  async deleteTask({commit}, tarefaId) {
    commit(Mutation.DELETE_TASK)
    return await TarefaApi.delete(tarefaId)
  },

  async removeEventDayCourses({commit, dispatch, rootState}, params) {
    dispatch('startLoading')
    try {
      await TarefaApi.deleteTaskList(params.taskIds, [params.scheduleId])
      commit(Mutation.SET_TASK_API_ERROR, null)

      let eventDayIndex
      const schedule = rootState.agenda.agenda.find(schedule => {
        eventDayIndex = schedule.eventos_agenda.findIndex(event => event.id === params.eventDayId)
        return eventDayIndex !== -1
      })

      commit(Mutation.REMOVE_EVENT_DAY_COURSES, {agenda: rootState.agenda.agenda, ...params})

      if (schedule && schedule.eventos_agenda[eventDayIndex].cursos.length === 0) {
        dispatch('removeEventDay', params.eventDayId)

        if (schedule.eventos_agenda.length === 0) {
          dispatch('deleteCronograma', schedule.id)
        } else {
          dispatch('updateScheduleDates', schedule.id)
        }
      }
    } catch (error) {
      commit(Mutation.SET_TASK_API_ERROR, error)
    }
    dispatch('stopLoading')
  },
  async updateEventDay({commit}, eventDay) {
    try {
      await TarefaApi.updateEventDay(eventDay)
      commit(Mutation.SET_TASK_API_ERROR, null)
    } catch (error) {
       commit(Mutation.SET_TASK_API_ERROR, error)
    }
  },
  async completeOrResetTask({commit}, params) {
    commit(Mutation.STORE_TASK_STATUS_CHANGE, params)
    await TarefaApi.completeOrResetTask(params.taskId, params.status)
  },

  async completeOrResetDayTasks({commit, dispatch, rootState}, params) {
    dispatch('startLoading')
    commit(Mutation.CHANGE_DAY_TASKS_STATUS, {agenda: rootState.agenda.agenda, ...params})
    await TarefaApi.completeOrResetTaskList(params.taskIds, params.status)
    dispatch('stopLoading')
  },

  loadTasksStatusChanges({commit, rootState}) {
    commit(Mutation.LOAD_TASKS_STATUS_CHANGES, rootState.agenda.agenda)
    commit(Mutation.RESET_DAY_TASKS_CHANGES)
  },

  async completeOpenedTask({commit, rootState}, params) {
    commit(Mutation.CHANGE_TASK_STATUS, {agenda: rootState.agenda.agenda, ...params})
    await TarefaApi.completeOrResetTask(params.taskId, params.status)
  },

  resetApiTaskError({commit}) {
    commit(Mutation.SET_TASK_API_ERROR, null)
  }
}
